import React from "react";
import "../App.css";
import { useInView } from "../hooks/useInView";
import { useNavigate } from "react-router-dom";
import { useCareModal } from "../context/CareModalContext";
import CQC from "../images/CQC.jpg";
import NHRA from "../images/nhra.jpeg";
import Training from "../images/staff-training.jpg"

const TimelineItem = ({ year, text, side }) => {
  const [ref, inView] = useInView();

  return (
    <div
      ref={ref}
      className={`timeline-item ${side === "left" ? "from-left" : "from-right"} ${
        inView ? "in-view" : ""
      }`}
    >
      <div className="timeline-year">{year}</div>
      <div className="timeline-dot" />
      <div className="timeline-card">
        <h4>{text}</h4>
      </div>
    </div>
  );
};

const About = () => {
  const navigate = useNavigate();
    const { openBookCare, openJoinTeam } = useCareModal();
  return (
    <>
      {/* HERO */}
      <section className="hero about-hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">
            Caring for those who once cared for us
          </h1>
          <p className="hero-subtitle">
            Providing dignity, safety, and compassion in every service we offer.
          </p>

          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={openBookCare}>Book For Care</button>
          <button className="btn btn-light" onClick={openJoinTeam}>Join Our Team</button>
          </div>
        </div>
      </section>

      {/* MISSION & VALUES */}
      <section className="section mission-values">
        <h2 className="section-title">Mission &amp; Values</h2>

        <div className="values-grid">
          <article className="value-card">
            <div className="value-icon">💠</div>
            <h3>Dignity</h3>
            <p>
              We believe every person deserves to be treated with respect,
              compassion, and understanding. Our carers uphold dignity in every
              interaction, ensuring clients feel valued and heard.
            </p>
          </article>

          <article className="value-card">
            <div className="value-icon">🛡️</div>
            <h3>Safety</h3>
            <p>
              Your safety is our top priority. We maintain the highest standards
              of care, providing trusted, trained professionals who deliver
              support in a secure and comfortable environment.
            </p>
          </article>

          <article className="value-card">
            <div className="value-icon">🤝</div>
            <h3>Reliability</h3>
            <p>
              You can count on us for consistent, dependable care. Our team
              ensures timely, professional service — bringing peace of mind to
              clients and families every single day.
            </p>
          </article>
        </div>

        {/* gradient divider */}
        <div className="section-divider" />
      </section>

      {/* OUR STORY */}
      <section className="section about-story">
        <h2 className="section-title">Our Story</h2>
        <p className="about-story-text">
          Ndils Daily Care was founded in 2019 in the United Kingdom to deliver
          quality, person-centered care for older adults and people with
          disabilities. What began as a small, compassionate initiative has
          grown into a trusted service that empowers individuals to live with
          dignity and confidence every day.
        </p>

        {/* another divider */}
        <div className="section-divider" />
      </section>

      {/* TIMELINE – slide-in alternating */}
      <section className="section about-timeline">
        <div className="timeline-wrapper">
          <div className="timeline-line" />
          <div className="timeline-items">
            <TimelineItem
              year="2019"
              side="left"
              text="Ndils founded to provide in-home care."
            />
            <TimelineItem
              year="2020"
              side="right"
              text="Expanded team and training programs."
            />
            <TimelineItem
              year="2024"
              side="left"
              text="Partnered with community health programs."
            />
          </div>
        </div>
      </section>

      {/* COMPLIANCE BADGES */}
      <section className="section compliance">
  <h2 className="section-title">Compliance Badges</h2>

  <div className="compliance-row">
    {/* CQC Badge */}
    <div className="compliance-item">
      <p className="compliance-label">CQC Badge</p>
      <div className="compliance-badge">
        <img src={CQC} alt="CQC Badge" className="compliance-img" />
      </div>
    </div>

    {/* NHRA Logo */}
    <div className="compliance-item">
      <p className="compliance-label">NHRA Logo</p>
      <div className="compliance-badge">
        <img src={NHRA} alt="NHRA Logo" className="compliance-img" />
      </div>
    </div>

    {/* Training Certified */}
    <div className="compliance-item">
      <p className="compliance-label">Training Certified</p>
      <div className="compliance-badge">
        <img src={Training} alt="Staff Training Certified" className="compliance-img" />
      </div>
    </div>
  </div>
</section>

      {/* PARTNER WITH US CTA */}
      <section className="section partner-with-us">
        <h2 className="section-title">Partner With Us</h2>
        <p className="section-subtitle">
          Partner with us to deliver compassionate, reliable care.
        </p>

        <div className="partner-buttons">
          <button className="btn btn-primary"  onClick={() => navigate("/contact")}>Contact Us</button>
          <button className="btn partner-dark" onClick={openJoinTeam}>Join Our Team</button>
        </div>
      </section>
    </>
  );
};

export default About;
